import React from 'react';
// import AppBar from '@material-ui/core/AppBar';
// import TypoGraphy from '@material-ui/core/Typography';
// import ToolBar from '@material-ui/core/ToolBar';
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
// import { makeStyles } from '@material-ui/core/styles';

import AppRouter from "./component/AppRouter";
import NavBar from "./component/NavBar";
import Container from '@material-ui/core/Container';

function App() {
    return (
        <div>
            <NavBar/>
            <Container>
                <AppRouter/>
            </Container>
        </div>
    );
}


// const useStyles = makeStyles((theme) => ({
//   grow: {
//     flexGrow: 1,
//   },
//   menuButton: {

//   }

// }));

// function App() {
//   const classes = useStyles();

//   return (
//     <div>
//       <AppBar color="primary" position="static">
//         <ToolBar>
//           <IconButton
//             edge="start"
//             className={classes.menuButton}
//             color="inherit"
//             aria-label="open drawer"
//           >
//             <MenuIcon />
//           </IconButton>

//           <TypoGraphy variant="h6">Car Log Book</TypoGraphy>
//           <div className={classes.grow} />

//           <IconButton
//             edge="end"
//             className={classes.menuButton}
//             color="inherit"
//             aria-label="open drawer"
//           >
//             <AddCircleIcon />
//           </IconButton>
//         </ToolBar>
//       </AppBar>
//     </div>
//   );
// }

export default App;
